import request from '@/utils/request'

// 查询银河打本剧本宣传物料列表
export function listScriptMaterial(query) {
  return request({
    url: '/played/script/material/list',
    method: 'get',
    params: query
  })
}

// 查询银河打本剧本宣传物料详细
export function getScriptMaterial(id) {
  return request({
    url: '/played/script/material/' + id,
    method: 'get'
  })
}

// 新增银河打本剧本宣传物料
export function addScriptMaterial(data) {
  return request({
    url: '/played/script/material',
    method: 'post',
    data: data
  })
}

// 修改银河打本剧本宣传物料
export function updateScriptMaterial(data) {
  return request({
    url: '/played/script/material',
    method: 'put',
    data: data
  })
}

// 删除银河打本剧本宣传物料
export function delScriptMaterial(id) {
  return request({
    url: '/played/script/material/' + id,
    method: 'delete'
  })
}
